import { render, staticRenderFns } from "./Lots.vue?vue&type=template&id=4de5e580&scoped=true&"
import script from "./Lots.vue?vue&type=script&lang=ts&"
export * from "./Lots.vue?vue&type=script&lang=ts&"
import style0 from "./Lots.vue?vue&type=style&index=0&id=4de5e580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5e580",
  null
  
)

export default component.exports